import styled from "styled-components";

export const Container = styled.div`
    padding: 32px 122px;
`;

export const SectionContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const FirstColumn = styled.div`
    margin: 0 48px 0 0;
    width: 100%;
`;

export const SecondColumn = styled.div`
    width: 100%;
`;

export const ButtonAlignTp = styled.div`
display:flex;
justify-content:flex-end;
margin: 32px 0 0 0;
`;